<h2 class="title">Aclaraciones</h2>
<div class="text">
  <p #clarifications></p>
</div>